export default {
  ADD_NOTIFICATION: '@SHELL_ADD_NOTIFICATION',
  CLEAR_NOTIFICATION: '@SHELL_CLEAR_NOTIFICATION',
};
